import { useState, useCallback, useEffect } from "react";
import { NMAxiosInst } from "@neumetric/blueprint-lib/store";
import { AuditorAssessmentStats } from "./Assessments";
import { AuditWise } from "./AuditDetails";

export function AuditorStats(props) {
  const {
    user,
    departments,
    dateRangeList,
    dateRange,
    selectedAudit,
    setSelectedAudit,
    mode,
    setAuditList,
    exportPayload,
  } = props;
  const [audits, setAudits] = useState([]);
  const handleSaveAudits = useCallback((audits) => {
    setAudits(audits);
    setSelectedAudit(audits[0] ?? null);
  }, []);
  // NEW useEffect: prefetch audits when in Fusion mode
  useEffect(() => {
    async function loadAuditsForFusion() {
      if (mode === "fusion" && audits.length === 0) {
        try {
          const payload = { date_range_type: "last_365_days" };
          const res = await NMAxiosInst.post("/centrals/dashboard", payload);

          const list = Array.isArray(res?.audit_stat) ? res.audit_stat : [];

          // Step 1: Normalize data
          const normalized = list.map((r, i) => ({
            id: r?.asmt_id ?? null,
            title: r?.title ?? `Audit ${i + 1}`,
            controls: Number(r?.controls ?? 0),
            compliant: Number(r?.compliant ?? 0),
            gap: Number(r?.gap ?? 0),
            exemption: Number(r?.exemption ?? 0),
            pending: Number(r?.pending ?? 0),
            score: Number(r?.score ?? 0),
          }));

          // Step 2: Remove duplicates by title (keep the last one)
          const deduped = Array.from(
            new Map(
              normalized.map((a) => [
                a.title?.trim().replace(/\s+/g, " ").toLowerCase(), // normalized key
                a,
              ])
            ).values()
          );

          // Step 3: Set final list
          setAudits(deduped);
          setSelectedAudit(deduped[0] ?? null);
        } catch (err) {
          console.error("Error loading audits for fusion mode:", err);
        }
      }
    }

    loadAuditsForFusion();
  }, [mode, audits.length, setSelectedAudit]);

  // Automatically sync auditList
  useEffect(() => {
    setAuditList(audits);
  }, [audits]);

  return (
    <div className="o-auto">
      {((mode !== "fusion" && mode === "full") ||
        mode === "export_everything") && (
        <AuditorAssessmentStats
          handleSaveAudits={handleSaveAudits}
          user={user}
          dateRange={dateRange}
          dateRangeList={dateRangeList}
        />
      )}
      <AuditWise
        user={user}
        audits={audits}
        departments={departments}
        dateRange={dateRange}
        dateRangeList={dateRangeList}
        selectedAudit={selectedAudit}
        setSelectedAudit={setSelectedAudit}
        mode={mode}
        exportPayload={exportPayload}
      />
      {mode === "full" && (
        <div style={{ paddingTop: "100px" }}>
          <hr className="nm-hr nm-hr--center" />
        </div>
      )}
    </div>
  );
}
